import React from "react";
import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";

function LatestToken(props) {
    const { classes, latestToken } = props;

    return (
        <Table
            tableheadercolor="success"
        >
            <TableHead className={classes.negativeColor} color="primary">
                <TableRow>
                    <TableCell>S/N</TableCell>
                    <TableCell>Airline</TableCell>
                    <TableCell>Airport</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Number of Tokens</TableCell>
                    <TableCell>Created On</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {latestToken.map((item, key) => {
                    return (
                        <TableRow hover key={key}>
                            <TableCell>{key + 1}</TableCell>
                            <TableCell component="th">
                                {item.AirlineName}
                            </TableCell>
                            <TableCell component="th">
                                {item.Location}
                            </TableCell>
                            <TableCell>
                                &#8358; {appHelpers.numberWithCommasOnly(item.Amount)}
                            </TableCell>
                            <TableCell>{item.Token}</TableCell>
                            <TableCell>
                                {appHelpers.formatDateSpecific(
                                    item.CreatedDate,
                                    "MMM DD, YYYY"
                                )}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
}

export default LatestToken;



// WEBPACK FOOTER //
// ./src/views/Dashboard/latestToken.jsx